import React from 'react';

import ourBrand from './our-brand.jpg';
import ourBrandMobile from './our-brand-mobile.jpg';

import './styles.css';

export const OurBrand = () => (
   <div className="row" id="nuestra-marca">
      <img className="materiales only-desktop" src={ourBrand} alt="A lo Venezolano" />
      <img className="materiales only-mobile" src={ourBrandMobile} alt="A lo Venezolano" />
   </div>
);